import { Box, CircularProgress } from "@mui/material";

// Loading component for lazy-loaded routes
export const LoadingFallback = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="100vh"
  >
    <CircularProgress />
  </Box>
);
